export const ACTIVATE_GEOD = 'ACTIVATE_GEOD';
export const CLOSE_GEOD = 'CLOSE_GEOD';



// WEBPACK FOOTER //
// ./src/js/constants/ActionTypes.js